import React from 'react'
import { lowerCase, trimEnd } from 'lodash'
import PropTypes from 'prop-types'

import { EmptyState } from '../../../../components/generic'

export default function RoundsReportEmptyState(props) {
  const { preferredPeopleNominative, residents } = props

  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication'
  const imageSrc =
    'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/happy_logan.png'
  const preferredResidentTerm = lowerCase(
    trimEnd(preferredPeopleNominative, 's')
  )

  const residentMARLink =
    residents && residents.length
      ? `/residents/${residents[0].id}/emar`
      : '/residents'

  return (
    <div style={styles.wrapper}>
      <EmptyState imageSrc={imageSrc} title="No medications set up">
        <div style={styles.mainTextContainer}>
          <div>
            To know what medication have been administered or not administered,
          </div>
          <div>
            you’ll need to add a medication onto a {preferredResidentTerm}’s
            MAR.
          </div>
          <a href={residentMARLink} target="_blank" rel="noreferrer">
            Go to a {preferredResidentTerm}'s MAR &gt;
          </a>
        </div>
        <div>
          Learn more about adding medications{' '}
          <a href={helpLink} target="_blank" rel="noreferrer">
            here
          </a>
          .
        </div>
      </EmptyState>
    </div>
  )
}

RoundsReportEmptyState.propTypes = {
  preferredPeopleNominative: PropTypes.string.isRequired,
  residents: PropTypes.array,
}

const styles = {
  mainTextContainer: {
    marginBottom: 16,
  },
  wrapper: {
    marginTop: 16,
  },
}
